import React from "react";

import SvgI24Edit from "assets/icons/I24Edit";

import { Button, Typography } from "@material-ui/core";

import TrimmedText from "components/TrimmedText";

import {
  Container,
  DetailsContainer,
  TextContainer,
  TitleWrapper,
  BottomControlsContainer,
  ControlWrapper,
} from "./styles";

type Props = {
  title: string;
  image?: string;
  publishStatus?: string;
  date?: string;
  onEdit?: () => void;
  onDetailsClick?: () => void;
  onPublish?: () => void;
};

const CollectionCard = (props: Props) => {
  const { title, onEdit, onDetailsClick } = props;

  return (
    <Container>
      <DetailsContainer>
        <TextContainer>
          <TitleWrapper onClick={onDetailsClick}>
            <TrimmedText lines={1} text={title}>
              <Typography variant="h3" color="textPrimary">
                {title}
              </Typography>
            </TrimmedText>
          </TitleWrapper>
        </TextContainer>
        <BottomControlsContainer>
          <ControlWrapper>
            <Button
              startIcon={<SvgI24Edit />}
              variant="text"
              color="secondary"
              onClick={onEdit}
            >
              Edit
            </Button>
          </ControlWrapper>
        </BottomControlsContainer>
      </DetailsContainer>
    </Container>
  );
};

export default CollectionCard;
